var lib_core = require("lib-core");
var lib_geometry = require("lib-geometry");

var PosAngleScaleData = require("../abstract/posAngleScaleData.js");

var LogoData = function (root, center, angle, xscale, yscale, type, data) {
    var self = this;
    this.makeObservableTreeNode();

    this.addPosAngleScale(center, angle, xscale, yscale);

    this.type = this.value("type", true);
    this.data = this.value("data", true);

    this.boundingBox = this.cachedFunction("boundingBox",
        function(){
            var center = self.pos();
            //TODO: implement a decent bouding box
            return new lib_geometry.BoundingBox(center.x, center.y, 1, 1);
        },
        [[this, this.onBubble]] //TODO: specify
    );

    if(type != undefined) this.type(type);
    if(data != undefined) this.data(data);
};
lib_core.mixin(LogoData, lib_core.ObservableTreeNode, PosAngleScaleData);
lib_core.JsonParser.registerClass(LogoData, "LogoData");

module.exports = LogoData;

LogoData.prototype.remove = function () {
    this.ownerMember.removeValue(this); // remove object from it's ownerMember
};
